module.exports = __webpack_public_path__ + "img/contratos.ab580052.png";